import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "app-loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_ProgressSpinner)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}